import { Link } from 'react-router-dom'
import { styled } from 'styled-components'

export const StyledLink = styled(Link)`
  display: inline-flex;
`

export const StyledLogo = styled.img`
  height: 38px;
  width: auto;

  @media (max-width: 375px) {
    height: 28px;
  }
`
